import { useCallback, useEffect, useMemo } from "react";
import { TModelItem } from "../../../../../../services/api/instances/modelsApi/types";
import { useInitModelsOptions } from "./use-init-models-options";

export const useSelectModel = (
  modelId: string | null,
  updateObject: (model: TModelItem | null) => void,
) => {
  const { models } = useInitModelsOptions();
  const selectedModel = useMemo(() => {
    return models.find((m) => m.id === modelId) ?? null;
  }, [models, modelId]);

  const isStale =
    models.length > 0 && modelId !== null && selectedModel === null;

  useEffect(() => {
    if (!isStale) return;
    const fallback = models[0] ?? null;
    updateObject(fallback);
  }, [isStale, models, updateObject]);

  const handleSelectModel = useCallback(
    (model: TModelItem | null) => {
      const selectedModelItem = models.find((m) => m.id === model?.id);
      updateObject(selectedModelItem ?? null);
    },
    [models, updateObject],
  );

  const displayedModel =
    selectedModel ?? (isStale ? (models[0] ?? null) : null);

  return {
    models,
    selectedModel: displayedModel,
    handleSelectModel,
  };
};
